import { render } from "./MainLayout.vue?vue&type=template&id=658629e8&scoped=true"
import script from "./MainLayout.vue?vue&type=script&lang=ts"
export * from "./MainLayout.vue?vue&type=script&lang=ts"

import "./MainLayout.vue?vue&type=style&index=0&id=658629e8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-658629e8"

export default script